import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';

import DiscountDetails from './discountDetails.jsx';
import { data as agreementDataPropTypes } from '../agreementPropTypes';
import partnerPropTypes from '../partnerPropTypes';
import formatOreToKroner from '../../lib/formatOreToKroner.js';

class SuggestDiscount extends PureComponent {
    constructor() {
        super();
        this.state = {
            suggestedKronerDiscount: 0,
            submitted: false,
            termsAccepted: false,
        };
        this.updateSuggestedDiscount = this.updateSuggestedDiscount.bind(this);
        this.handleClickSendSuggestion = this.handleClickSendSuggestion.bind(
            this
        );
        this.handleClickTermsAccepted = this.handleClickTermsAccepted.bind(
            this
        );
    }

    updateSuggestedDiscount(e) {
        this.setState({
            suggestedKronerDiscount: Math.abs(Number(e.target.value)),
        });
    }

    isValid() {
        return (
            !this.validateSuggestion().invalid &&
            !this.validateChecked().invalid
        );
    }

    validateSuggestion() {
        const { agreement } = this.props;
        const { suggestedKronerDiscount } = this.state;
        const suggestedOreDiscount = suggestedKronerDiscount * 100;

        if (suggestedOreDiscount > agreement.total) {
            return {
                invalid: true,
                message: 'Avslaget kan ikke være høyere enn hva som er betalt.',
            };
        }

        return { invalid: false };
    }

    validateChecked() {
        return { invalid: !this.state.termsAccepted };
    }

    handleClickSendSuggestion() {
        const { onConfirm } = this.props;
        const { suggestedKronerDiscount } = this.state;

        this.setState({
            submitted: true,
        });

        if (this.isValid()) {
            onConfirm({
                discount: suggestedKronerDiscount * 100,
            });
        }
    }

    handleClickTermsAccepted() {
        this.setState({
            termsAccepted: !this.state.termsAccepted,
        });
    }

    render() {
        const {
            agreement,
            cancelLink,
            enableConfirm,
            feePercentage,
            partner,
            role,
        } = this.props;
        const {
            suggestedKronerDiscount,
            termsAccepted,
            submitted,
        } = this.state;

        const suggestedOreDiscount = suggestedKronerDiscount * 100;
        const discountFee = Math.floor(
            suggestedOreDiscount * (feePercentage / 100)
        );
        const recipientAmount = agreement.total - suggestedOreDiscount;
        const maxInput = Math.floor(agreement.total / 100);

        const showSuggestionInvalid = this.validateSuggestion().invalid;
        const showAcceptTermsInvalid =
            submitted && this.validateChecked().invalid;

        return (
            <div>
                <div className="centerify r-phl">
                    <div
                        className={`inlineblockify r-size1of3 ${classNames({
                            invalid: showSuggestionInvalid,
                        })}`}
                    >
                        <div className="flex align-items-center">
                            <input
                                type="number"
                                min={0}
                                max={maxInput}
                                className="flex-grow1 centerify"
                                style={{
                                    boxShadow: 'none',
                                    borderRadius: 0,
                                    border: '0',
                                    borderBottom: '1px solid grey',
                                    fontSize: '2em',
                                }}
                                value={suggestedKronerDiscount}
                                onChange={this.updateSuggestedDiscount}
                            />
                            <span>kr</span>
                        </div>
                    </div>
                    <div className="pbl ptm mln strong">
                        <p>
                            {role === 'BUYER'
                                ? `${partner.name} vil motta ${formatOreToKroner(
                                      recipientAmount
                                  )}`
                                : `Du vil motta ${formatOreToKroner(
                                      recipientAmount
                                  )}`}
                        </p>

                        {showSuggestionInvalid && (
                            <span className="help-inline cherry">
                                {this.validateSuggestion().message}
                            </span>
                        )}
                    </div>
                </div>

                <div className="r-pbm">
                    <DiscountDetails
                        agreement={agreement}
                        partner={partner}
                        role={role}
                        discount={suggestedOreDiscount}
                        discountFee={discountFee}
                    />
                </div>

                <div
                    className={`formelement r-mtl ${classNames({
                        invalid: showAcceptTermsInvalid,
                    })}`}
                >
                    <div className="input">
                        <div className="fancyinput">
                            <input
                                type="checkbox"
                                id="fancycheckbox1"
                                onClick={this.handleClickTermsAccepted}
                                value={termsAccepted}
                            />
                            <label htmlFor="fancycheckbox1">
                                Jeg forstår at jeg ikke kan trekke forslaget.
                            </label>
                            {showAcceptTermsInvalid && (
                                <span className="help-inline">
                                    Du må bekrefte at du forstår at forslaget er
                                    bindende.
                                </span>
                            )}
                        </div>
                    </div>
                </div>

                <div className="centerify">
                    <div className="r-phl r-ptl">
                        <button
                            className={`primary fullwidth mtl ${classNames({
                                inprogress: !enableConfirm,
                            })}`}
                            disabled={!enableConfirm}
                            onClick={this.handleClickSendSuggestion}
                        >
                            Send forslag
                        </button>

                        <div className="mtl">
                            <Link to={cancelLink}>Avbryt</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

SuggestDiscount.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    cancelLink: PropTypes.string.isRequired,
    feePercentage: PropTypes.number.isRequired,
    onConfirm: PropTypes.func.isRequired,
    partner: partnerPropTypes.isRequired,
    enableConfirm: PropTypes.bool.isRequired,
    role: PropTypes.oneOf(['BUYER', 'SELLER']).isRequired,
};

export default SuggestDiscount;



// WEBPACK FOOTER //
// ./safeTrade/resolution/suggestDiscount.jsx